var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundDuskmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1394,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M651.135 319.692C559.924 232.028 489.179 123.285 446.702 1.287h-497.53C19.017 121.2 59.075 260.623 59.075 409.414c0 365.918-242.045 675.266-574.787 776.876v206.16H563.991c-101.92-135.72-162.316-304.38-162.316-487.167 0-230.072 95.717-437.778 249.46-585.565v-.026z",
    fill: "url(#prefix__paint0_linear_2197_37702)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M650.829 319.689C796.849 179.34 995.206 93.066 1213.75 93.066c218.54 0 416.9 86.3 562.92 226.623 74.73-71.834 135.74-157.825 178.74-253.648V1.285H446.396c42.477 121.998 113.248 230.766 204.433 318.404z",
    fill: "url(#prefix__paint1_linear_2197_37702)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.074 409.414c0-148.791-40.058-288.188-109.901-408.127h-464.886V1186.26c332.742-101.58 574.787-410.954 574.787-776.871v.025z",
    fill: "url(#prefix__paint2_linear_2197_37702)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1776.97 319.692c-146.02 140.349-344.38 226.623-562.92 226.623-218.538 0-416.895-86.3-562.915-226.623-153.769 147.787-249.46 355.493-249.46 585.565 0 182.763 60.396 351.423 162.316 487.173H1864.14c35.99-47.93 66.78-99.94 91.57-155.26V573.366c-42.96-95.849-104-181.814-178.74-253.648v-.026z",
    fill: "url(#prefix__paint3_linear_2197_37702)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M651.135 319.692c146.02 140.349 344.377 226.623 562.915 226.623 218.54 0 416.9-86.3 562.92-226.623-146.02-140.349-344.38-226.623-562.92-226.623-218.538 0-416.895 86.299-562.915 226.623z",
    fill: "url(#prefix__paint4_linear_2197_37702)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint0_linear_2197_37702",
    x1: 1211.97,
    y1: 1392.43,
    x2: -2030.17,
    y2: -57.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#4FCCB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#883AC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint1_linear_2197_37702",
    x1: 266.256,
    y1: 394.348,
    x2: 3339.15,
    y2: 394.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#4FCCB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#883AC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint2_linear_2197_37702",
    x1: -1095.04,
    y1: 538.217,
    x2: 816.34,
    y2: 538.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#4FCCB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#883AC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint3_linear_2197_37702",
    x1: 1258.22,
    y1: 1868.99,
    x2: 1258.22,
    y2: -694.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#4FCCB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#883AC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint4_linear_2197_37702",
    x1: 862.583,
    y1: 779.709,
    x2: 1643.58,
    y2: -638.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#4FCCB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#883AC3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundDuskmin);
export default __webpack_public_path__ + "static/media/background-dusk.min.3785b10c994bccd28dbfc5b1be10f031.svg";
export { ForwardRef as ReactComponent };